import { AbstractControl, ValidationErrors } from '@angular/forms';

export function atLeastOneCheckboxValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return { required: true };
  }
  
  const hasSelection = Object.values(control.value).some((val: any) => val === true);
  return hasSelection ? null : { required: true };
}